import React from 'react';
import styles from './index.css';
import PropTypes from 'prop-types';
import { LazyImg } from '@ifeng-fe/ui_pc_lazyLoad';
import { formatImageWebpAuto } from '../../../../../../base/publicMethod/index';
import ShortRelate from '../shortRelate';
import ShortHead from '../shortHead';
import ShortFooter from '../shortFooter';
import { pics } from '../../../../../pics';

const isVideoShare =
    (typeof window === 'object' && window.allData && window.allData.docData && window.allData.docData.isVideoShare) ||
    false;
const smallLazyImg =
    'data:image/svg+xml;utf8,<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="342" height="342"><text x="80" y="200" fill="%23dcdcdc"></text></svg>';
const bigLazyImg =
    'data:image/svg+xml;utf8,<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="360" height="200"><text x="120" y="110" fill="%23dcdcdc"></text></svg>';

class ShortPic extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    handleShowPic = (index) => {
        const { content } = this.props;
        const { imageList } = content;

        if (imageList) {
            const list = imageList.map((item) => {
                const { url } = item;
                const reg = /_w([0-9]+)_h([0-9]+)\.[a-zA-Z]+$/gi;

                if (reg.test(url)) {
                    const width = parseInt(RegExp.$1);
                    const height = parseInt(RegExp.$2);

                    return { url, width, height };
                } else {
                    const width = document.body.clientWidth || document.documentElement.clientWidth;
                    const height = document.body.clientHeight || document.documentElement.clientHeight;

                    return { url, width, height };
                }
            });
            pics.show({ list, current: index });
        }
    };

    lessThanThreeImg = (wbImages) => {
        return (
            <ul className={styles.wbImgBox}>
                <li className={styles.wbImgGroup}>
                    {wbImages.length === 1 && (
                        <div
                            className={`${styles.wbImgItem} ${styles.onlyWbImgItemPic}`}
                            onClick={() => {
                                this.handleShowPic(0);
                            }}>
                            <LazyImg className={styles.wbImgItemPic} placeholder={bigLazyImg} src={wbImages[0].url} />
                            {wbImages[0].isLongImage && !wbImages[0].isGifImgage && (
                                <span className={styles.wbImgMark}>长图</span>
                            )}
                            {wbImages[0].isGifImgage && <span className={styles.wbImgMark}>动图</span>}
                        </div>
                    )}
                    {wbImages.length === 2 && (
                        <>
                            {wbImages.map((item, index) => (
                                <div
                                    key={index}
                                    className={styles.wbImgItem}
                                    onClick={() => {
                                        this.handleShowPic(index);
                                    }}>
                                    <div className={styles.wbImgItemBox}>
                                        <LazyImg
                                            className={styles.wbImgItemPic}
                                            placeholder={smallLazyImg}
                                            src={item.url}
                                        />
                                        {item.isLongImage && !item.isGifImgage && (
                                            <span className={styles.wbImgMark}>长图</span>
                                        )}
                                        {item.isGifImgage && <span className={styles.wbImgMark}>动图</span>}
                                    </div>
                                </div>
                            ))}
                            <div className={styles.wbImgItem} />
                        </>
                    )}
                    {wbImages.length === 3 &&
                        wbImages.map((item, index) => (
                            <div
                                key={index}
                                className={styles.wbImgItem}
                                onClick={() => {
                                    this.handleShowPic(index);
                                }}>
                                <div className={styles.wbImgItemBox}>
                                    <LazyImg
                                        className={styles.wbImgItemPic}
                                        placeholder={smallLazyImg}
                                        src={item.url}
                                    />
                                    {item.isLongImage && !item.isGifImgage && (
                                        <span className={styles.wbImgMark}>长图</span>
                                    )}
                                    {item.isGifImgage && <span className={styles.wbImgMark}>动图</span>}
                                </div>
                            </div>
                        ))}
                </li>
            </ul>
        );
    };

    equalFourImg = (wbImages) => {
        const imageGroup = [];

        for (let i = 0, len = wbImages.length; i < len; i += 2) {
            imageGroup.push(wbImages.slice(i, i + 2));
        }

        return (
            <ul className={styles.wbImgBox}>
                {imageGroup.map((itemGroup, indexGroup) => (
                    <li key={indexGroup} className={styles.wbImgGroup}>
                        {itemGroup.map((item, index) => (
                            <div
                                key={index}
                                className={styles.wbImgItem}
                                onClick={() => {
                                    this.handleShowPic(indexGroup * 2 + index);
                                }}>
                                <div className={styles.wbImgItemBox}>
                                    <LazyImg
                                        className={styles.wbImgItemPic}
                                        placeholder={smallLazyImg}
                                        src={item.url}
                                    />
                                    {item.isLongImage && !item.isGifImgage && (
                                        <span className={styles.wbImgMark}>长图</span>
                                    )}
                                    {item.isGifImgage && <span className={styles.wbImgMark}>动图</span>}
                                </div>
                            </div>
                        ))}
                        <div className={styles.wbImgItem} />
                    </li>
                ))}
            </ul>
        );
    };

    greaterThanFiveImg = (wbImages) => {
        const imageGroup = [];
        const fillIndex = 3 - (wbImages.length % 3);

        for (let j = 0; j < fillIndex; j++) {
            if (fillIndex !== 3) {
                wbImages.push('');
            }
        }
        for (let i = 0, len = wbImages.length; i < len; i += 3) {
            imageGroup.push(wbImages.slice(i, i + 3));
        }

        return (
            <ul className={styles.wbImgBox}>
                {imageGroup.map((itemGroup, indexGroup) => (
                    <li key={indexGroup} className={styles.wbImgGroup}>
                        {itemGroup.map((item, index) => (
                            <div
                                key={index}
                                className={styles.wbImgItem}
                                onClick={() => {
                                    this.handleShowPic(indexGroup * 3 + index);
                                }}>
                                {item.url && (
                                    <div className={styles.wbImgItemBox}>
                                        <LazyImg
                                            className={styles.wbImgItemPic}
                                            placeholder={smallLazyImg}
                                            src={item.url}
                                        />
                                        {item.isLongImage && !item.isGifImgage && (
                                            <span className={styles.wbImgMark}>长图</span>
                                        )}
                                        {item.isGifImgage && <span className={styles.wbImgMark}>动图</span>}
                                    </div>
                                )}
                            </div>
                        ))}
                    </li>
                ))}
            </ul>
        );
    };

    render() {
        const { content } = this.props;
        let images = (content.thumbnails && content.thumbnails.image) || [];
        let relateData = {};
        const gotoUrl =
            (content.url && isVideoShare
                ? `https://ishare.ifeng.com/c/vs/${content.url.split('/').pop()}`
                : content.url) || '';

        if (content.subItem) {
            relateData = {
                type: content.subItem.type === 'phvideo' ? 'video' : 'doc',
                url:
                    (content.subItem.link && isVideoShare
                        ? `https://ishare.ifeng.com/c/vs/${content.subItem.link.weburl.split('/').pop()}`
                        : content.subItem.link.weburl) || '',
                logo: (content.subItem.subscribe && content.subItem.subscribe.logo) || '',
                sourceFrom: (content.subItem.subscribe && content.subItem.subscribe.catename) || '',
                title: content.subItem.intro || '',
                image: (content.subItem.thumbnail && content.subItem.thumbnail.replace(/\.webp|_webp/g, '')) || '',
                duration: (content.subItem.phvideo && content.subItem.phvideo && content.subItem.phvideo.length) || '',
            };
        }
        images = images.map((item) => {
            let url = item.url;
            let isLongImage = false;
            let isGifImgage = false;

            if (url.includes('.gif')) {
                isGifImgage = true;
            }

            if (images.length === 1) {
                url = url.replace(/\.webp|_webp/g, '');
            } else {
                url = url.includes('.gif')
                    ? url.replace(/\.webp|_webp/g, '')
                    : formatImageWebpAuto(url.replace(/\.webp|_webp/g, ''), 340, 340);
            }

            const imgReg =
                (url &&
                    url.split('/') &&
                    url.split('/').pop() &&
                    url.split('/').pop().split('.') &&
                    url.split('/').pop().split('.')[0] &&
                    url.split('/').pop().split('.')[0].split('_')) ||
                [];
            const imgWidth = (imgReg[1] && imgReg[1].replace('w', '')) || 0;
            const imgHeight = (imgReg[2] && imgReg[2].replace('h', '')) || 0;

            if (imgWidth && imgHeight && (imgWidth / imgHeight < 0.66 || imgWidth / imgHeight > 2)) {
                isLongImage = true;
            }

            return {
                url,
                isLongImage,
                isGifImgage,
            };
        });

        return (
            <div
                className={`${styles.shortRelate} ${content.noTopLine ? styles.noTopLine : ''} ${
                    content.noBottomLine ? styles.noBottomLine : ''
                }`}>
                <ShortHead content={content} />
                {content.summary && (
                    <a
                        href={gotoUrl}
                        className={styles.shortRelateTitle}
                        dangerouslySetInnerHTML={{ __html: content.summary.replace(/\n/g, '<br />') }}
                    />
                )}
                {/* {relateData.title && <div className={styles.shortRelateBox}><ShortRelate content={relateData} /></div>} */}
                {images.length > 0 && (
                    <div className={styles.shortRelateBox}>
                        {images.length < 4 && this.lessThanThreeImg(images)}
                        {images.length === 4 && this.equalFourImg(images)}
                        {images.length > 4 && this.greaterThanFiveImg(images)}
                    </div>
                )}
                <ShortFooter content={content} />
            </div>
        );
    }
}

export default ShortPic;
